import { Menu, FileWarning } from "lucide-react";
import { Button } from "@headerhawk/ui";
import { FeedbackPopover } from "./feedback-popover";
import { UserMenu } from "./user-menu";

interface HeaderProps {
  onMenuClick: () => void;
  user: {
    email?: string;
    name?: string;
    picture?: string;
  };
}

export function Header({ onMenuClick, user }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b bg-background px-4 lg:px-6">
      {/* Mobile menu button */}
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden"
        onClick={onMenuClick}
      >
        <Menu className="h-5 w-5" />
        <span className="sr-only">Toggle menu</span>
      </Button>

      {/* Mobile logo */}
      <div className="flex items-center gap-2 lg:hidden">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
          <FileWarning className="h-5 w-5" />
        </div>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Feedback */}
      <FeedbackPopover />

      {/* User menu */}
      <UserMenu user={user} />
    </header>
  );
}
